<template>
	<div class="userList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="searchForm" class="demo-form-inline">
				<el-form-item>
					<el-input size clearable v-model="searchForm.agent_no" placeholder="请输入代理商编号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="searchForm.phone" placeholder="请输入代理商账号"></el-input>
				</el-form-item>
				<!-- <el-form-item>
					<el-input size clearable v-model="searchForm.up_code" placeholder="请输入方案编号"></el-input>
				</el-form-item> -->
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="handleSearch(searchForm)">查询</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<el-table :data="userTable" size="mini" border style="width: 100%" v-loading="loading">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column header-align="center" align="center" fixed type="index" label="ID" min-width="80">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="agent_no" label="代理商编号" min-width="120">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="real_name" label="代理商名称" min-width="120">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="phone" label="代理商账号" min-width="150">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="brand_name" label="关联政策" min-width="150">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="level" label="代理层级"min-width="150"></el-table-column>
				<el-table-column header-align="center" align="center" prop="parent_agent_no" label="上级编号"min-width="120">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="parent_phone" label="上级账号"min-width="120">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="parent_real_name" label="上级名称"min-width="120">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="up_code" label="方案编号"min-width="120">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="nums" label="已涨价商户"min-width="150">
					<template slot-scope="scope">
						<el-button @click="merchInfo(scope.row)" type="text" size="small">{{scope.row.nums}}</el-button>
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="create_time" label="创建时间" min-width="150">
				</el-table-column>
				<!-- 操作 -->
				<el-table-column header-align="center" align="center" fixed="right" label="操作" min-width="150">
					<template slot-scope="scope">
						<el-button @click="deleteAgent(scope.row)" type="text" size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:page-sizes="[10,20,50,100]" :current-page="currentPage" :page-size="pageSize" :total="total"
				layout="total, sizes, prev, pager, next, jumper" style="text-align: center"></el-pagination>
		</el-card>

		<el-dialog title="已涨价商户" :visible.sync="dialogVisible" width="65%" :before-close="handleClose">
			<el-card class="box-card" shadow="hover">
				<el-form :inline="true" :model="merchForm" class="demo-form-inline">
					<el-form-item>
						<el-input size clearable v-model="merchForm.merchant_number" placeholder="请输入商户编号"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
							@click="merchhandleSearch(merchForm)">查询</el-button>
					</el-form-item>
				</el-form>
			</el-card>
			<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
				<el-table :data="merchantList" size="mini" border style="width: 100%" v-loading="loading">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column header-align="center" align="center" fixed type="index" label="ID" min-width="80">
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="merchant_number" label="商户编号" min-width="120">
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="name" label="商户名称" min-width="150">
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="create_time" label="入网时间" min-width="150">
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="front_rate" label="原费率"min-width="150">
						<template slot-scope="scope">
							{{scope.row.front_rate}} %
						</template>
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="base_rate" label="涨价后费率"min-width="120">
						<template slot-scope="scope">
							{{scope.row.base_rate}} %
						</template>
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="sec_fee" label="秒到费"min-width="150">
						<template slot-scope="scope">
							{{scope.row.sec_fee}} 元
						</template>
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="is_effective" label="政策是否已生效"min-width="150">
						<template slot-scope="scope">
							<span v-if="scope.row.is_effective == 1">已生效</span>
							<span v-if="scope.row.is_effective == 2">未生效</span>
						</template>
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="effective_date" label="政策生效时间"min-width="150">
						<template slot-scope="scope">
							{{scope.row.effective_date}}
						</template>
					</el-table-column>
					<!-- 操作 -->
					<el-table-column header-align="center" align="center" fixed="right" label="操作" min-width="150">
						<template slot-scope="scope">
							<el-button @click="deleteMerchantList(scope.row)" type="text" size="small">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<!-- 分页部分 -->
				<el-pagination background @size-change="merchhandleSizeChange" @current-change="merchhandleCurrentChange"
					:page-sizes="[10,20,50,100]" :current-page="merchcurrentPage" :page-size="merchpageSize" :total="merchtotal"
					layout="total, sizes, prev, pager, next, jumper" style="text-align: center"></el-pagination>
			</el-card>
			
			
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: "creditCardaDjustment",
		data() {
			return {
				searchForm: {
					id:'',
					page: 1,
					limit: 10,
				},
				userTable: [],
				currentPage: 1, //当前页码
				pageSize: 10, //条数
				total: 0, //总数
				loading: false,
				//添加方案 
				dialogVisible: false,
				merchForm:{
					id:'',
					page: 1,
					limit: 10,
				},
				merchantList:[],
				merchcurrentPage: 1, //当前页码
				merchpageSize: 10, //条数
				merchtotal: 0, //总数
			}
		},
		mounted() {
			this.searchForm.id = this.$route.query.id; //取id
			this.getData(this.searchForm);
		},

		methods: {
			
			//代理删除
			deleteAgent(val) {
				this.$confirm("确定删除?", '提 示', {
					type: 'warning',
					distinguishCancelAndClose: true,
					confirmButtonText: '确 定',
					cancelButtonText: '取 消'
				}).then(() => {
					let data = {
						id: val.id,
					};
					this.frozenLoading = true; //防重复
					this.$api.post('terminal/ManageFeePolicyUserDel', data, res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: res.msg,
								duration: 2000,
							})
							let params = this.searchForm;
							this.getData(params);
							this.frozenLoading = false;
						} else {
							this.$message.error(res.msg);
							this.frozenLoading = false;
						}
					})
				}).catch(() => {

				})
			},
			//商户删除
			deleteMerchantList(val) {
				this.$confirm("确定删除?", '提 示', {
					type: 'warning',
					distinguishCancelAndClose: true,
					confirmButtonText: '确 定',
					cancelButtonText: '取 消'
				}).then(() => {
					let data = {
						id: val.id,
					};
					this.frozenLoading = true; //防重复
					this.$api.post('terminal/ManageFeePolicySideDel', data, res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: res.msg,
								duration: 2000,
							})
							let params = this.merchForm;
							this.merchgetData(params);
							this.frozenLoading = false;
						} else {
							this.$message.error(res.msg);
							this.frozenLoading = false;
						}
					})
				}).catch(() => {

				})
			},
			handleSearch(searchForm) { //搜索
				this.currentPage = 1;
				searchForm.page = 1;
				this.getData(searchForm);
			},
			//商户搜索
			merchhandleSearch(merchForm) { //搜索
				this.currentPage = 1;
				merchForm.page = 1;
				this.merchgetData(merchForm);
			},
			//关闭方法
			handleClose() {
				this.merchantList=[];
				this.dialogVisible = false;
				
			},
			merchInfo(row){
				this.merchForm = {
					id:row.id,
					page: 1,
					limit: 10,
				};
				this.merchgetData(this.merchForm);
				this.dialogVisible = true;
			},
			//商户分页
			merchhandleCurrentChange(page) { //当前选中页
				this.merchcurrentPage = page;
				this.merchForm.page = page;
				this.merchForm.limit = this.merchpageSize;
				this.merchgetData(this.merchForm);
			},
			merchhandleSizeChange(limit) { //条数
				this.merchcurrentPage = 1;
				this.merchpageSize = limit;
				this.merchForm.page = 1;
				this.merchForm.limit = limit;
				this.merchgetData(this.merchForm);
			},
			merchgetData(params) { //初始化数据
				this.loading = true;
				this.$api.post("terminal/ManageFeePolicySideList", params, res => {
					if (res.code == 0) {
						let data = res.data;
						this.merchtotal = data.count; //总数
						this.merchantList = data.list;
					} else {
						this.$message.error(res.msg);
					}
					//渲染结束后取消加载
					this.loading = false;
				})
			},
			//分页
			handleCurrentChange(page) { //当前选中页
				this.currentPage = page;
				this.searchForm.page = page;
				this.searchForm.limit = this.pageSize;
				this.getData(this.searchForm);
			},
			handleSizeChange(limit) { //条数
				this.currentPage = 1;
				this.pageSize = limit;
				this.searchForm.page = 1;
				this.searchForm.limit = limit;
				this.getData(this.searchForm);
			},
			getData(params) { //初始化数据
				this.loading = true;
				this.$api.post("terminal/ManageFeePolicyUserList", params, res => {
					if (res.code == 0) {
						let data = res.data;
						this.total = data.count; //总数
						this.userTable = data.list;
					} else {
						this.$message.error(res.msg);
					}
					//渲染结束后取消加载
					this.loading = false;
				})
			},
		}
	};
</script>

<style scoped>
	.el-input,
	.el-select {
		width: 180px !important;
	}
</style>
